import React from "react";
import { useTinyHost } from "@tiny/host-contract";

import { Grid, Button, BoxPanel, EmptyState } from "@tiny/components";
import useBreakpoints from "@tiny/components/src/hooks/useBreakpoints";
import Group from "@tiny/icons/generated/Group";

interface NoAudiencePanelProps {
  onClickUploadFile: () => void;
}

function NoAudiencePanel(props: NoAudiencePanelProps) {
  const { onClickUploadFile } = props;

  const { mdUp } = useBreakpoints();

  const { navigate } = useTinyHost();

  return (
    <BoxPanel hideHeader>
      <EmptyState
        icon={<Group />}
        title="No audience created."
        message="Feels rather empty here! Let’s do something about that. Click the button below to start adding your audience."
      >
        <Grid item container xs={12} spacing={3}>
          {mdUp && (
            <Grid item>
              <Button
                color="primary"
                variant="outlined"
                onClick={onClickUploadFile}
              >
                Upload File
              </Button>
            </Grid>
          )}
          <Grid item>
            <Button
              variant="outlined"
              onClick={() => navigate.to("/main/integrations")}
            >
              Add integration
            </Button>
          </Grid>
        </Grid>
      </EmptyState>
    </BoxPanel>
  );
}

export default NoAudiencePanel;
